// Node
import { min, max } from 'underscore';

export default class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.pages = this.pages.bind(this);
    this.setPage = this.setPage.bind(this);
    this.handlePrevPageClick = this.handlePrevPageClick.bind(this);
    this.handleNextPageClick = this.handleNextPageClick.bind(this);
    this.handleFirstPageClick = this.handleFirstPageClick.bind(this);
    this.handleHastPageClick = this.handleHastPageClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    let pageChanged = this.props.pageNum !== nextProps.pageNum;
    let pageCountChanged = this.props.pageCount !== nextProps.pageCount;
    return pageChanged || pageCountChanged;
  }

  pages() {
    const min = (this.props.pageNum - 1) > 0
      ? this.props.pageNum - 1
      : false;

    const max = (this.props.pageNum + 2) < this.props.pageCount
      ? this.props.pageNum + 1
      : false;

    const mid = (this.props.pageNum !== 0) && (this.props.pageNum < (this.props.pageCount - 1))
      ? this.props.pageNum
      : false;

    return [min, mid, max].filter(Number);
  }

  setPage(page) {
    this.props.setPage(page);
  }

  handlePrevPageClick() {
    this.setPage(max([0,this.props.pageNum - 1]));
  }

  handleNextPageClick() {
    this.setPage(min([this.props.pageCount - 1, this.props.pageNum + 1]));
  }

  handleFirstPageClick() {
    if (this.props.pageNum !== 0) {
      this.setPage(0);
    }
  }

  handleHastPageClick() {
    if (this.props.pageNum != this.props.pageCount - 1) {
      this.setPage(this.props.pageCount - 1)
    }
  }

  render() {
    if (this.props.pageCount < 2) {
      return null;
    }

    let prevPage =
      this.props.pageNum > 0 ?
        <div className='pagination__arrow pagination__arrow-prev flex-center'
             onClick={this.handlePrevPageClick}
        >
          <svg width='13'
               height='13'
               viewBox='0 0 13 13'
               fill='none'
               xmlns='http://www.w3.org/2000/svg'
          >
            <path fillRule='evenodd'
                  clipRule='evenodd'
                  d='M6.5 13L7.6375 11.8625L3.0875 7.3125L13 7.3125L13 5.6875L3.0875 5.6875L7.6375 1.1375L6.5 0L0 6.5L6.5 13Z'
                  fill='#333333'
            />
          </svg>
        </div>
        : undefined;

    let firstPage =
      <li className={'pagination__item ' + (this.props.pageNum === 0 ? 'pagination__item_active' : '')}
          onClick={this.handleFirstPageClick}
      >
        <a className='link_black'>1</a>
      </li>;

    let startDots =
      this.props.pageNum > 2
        ? <li className='pagination__item'>...</li>
        : undefined;

    let endDots =
      this.props.pageNum + 3 < this.props.pageCount
        ? <li className='pagination__item'>...</li>
        : undefined;

    let lastPage =
      this.props.pageCount > 1 ?
        <li className={'pagination__item ' + (this.props.pageNum === this.props.pageCount - 1 ? 'pagination__item_active' : '')}
            onClick={this.handleHastPageClick}
        >
          <a className='link_black'>
            {this.props.pageCount}
          </a>
        </li>
        : undefined;

    let nextPage =
      this.props.pageNum + 1 < this.props.pageCount ?
        <div className='pagination__arrow pagination__arrow-next flex-center rotate'
             onClick={this.handleNextPageClick}
        >
          <svg width='13'
               height='13'
               viewBox='0 0 13 13'
               fill='none'
               xmlns='http://www.w3.org/2000/svg'
          >
            <path fillRule='evenodd'
                  clipRule='evenodd'
                  d='M6.5 13L7.6375 11.8625L3.0875 7.3125L13 7.3125L13 5.6875L3.0875 5.6875L7.6375 1.1375L6.5 0L0 6.5L6.5 13Z'
                  fill='#333333'
            />
          </svg>
        </div>
        : undefined;

    return (
      <ul className='pagination'>
        {prevPage}
        <div className='pagination__numbers'>
          {firstPage}
          {startDots}
          {this.pages().map(page => {
            return <li className={'pagination__item ' + (this.props.pageNum === page ? 'pagination__item_active' : '')}
                        onClick={() => this.setPage(page)}
                        key={page}
            >
              <a className='link_black'>{page + 1}</a>
            </li>;
          })
          }
          {endDots}
          {lastPage}
        </div>
        <div className='next-nav text-nav'>
          {nextPage}
        </div>
      </ul>
    );
  }
}
